import { Location } from '@angular/common';
import { Component } from '@angular/core';

import { AnalyticsService } from '../../../../app/core/services/analytics/analytics.service';
import { ErrorDecoderHelper } from '../../helpers/error-decoder/error-decoder.helper';
import { FormatedErrorInterface } from '../../interface/error-state.interface';

@Component({
  selector: 'app-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss']
})
export class GenericErrorComponent {
  codeError?: string;
  correlationId?: string;
  timerRedirect = 10;
  attemptRedirect = 3;

  constructor(private locationState: Location, private analyticsService: AnalyticsService) {
    this.attemptRedirect = Number.parseFloat(sessionStorage.getItem('attempt_redirect') || '3');
    this.attemptRedirect--;
    sessionStorage.setItem('attempt_redirect', this.attemptRedirect.toString());

    const locationStateError = ((this.locationState.getState() as FormatedErrorInterface) || {}).error;
    this.codeError = ErrorDecoderHelper.getCodeErro(locationStateError);
    this.correlationId = ErrorDecoderHelper.getCorrelationId(locationStateError);

    const statusCode = this.codeError?.toLowerCase() ?? '';
    const error = this.codeError?.toString().toLowerCase() ?? '';
    this.trackGenericError(statusCode, error);

    // tslint:disable-next-line:early-exit
    if (this.attemptRedirect > 0) {
      setInterval(() => {
        this.timerRedirect--;
        if (this.timerRedirect === 0) {
          location.href = '/';
        }
      }, 1000);
    }
  }

  trackGenericError(statusCode: string, error: string) {
    this.analyticsService.trackError(`erro:generico:${statusCode}-${error}:${this.correlationId?.toLowerCase()}`);
  }
}
